export const DEFAULT_APP_BRAND = 'HQO';
